// packages
import { Fragment, h, render } from 'preact';
import { useState } from 'preact/hooks';

// local
import { RESULTS_URL, RACE_MAPPING } from './constants';
import Result from './Result';
import { useInterval } from './hooks';
import { prepareResults } from './utils';

const fetchResults = () => fetch(RESULTS_URL).then(res => res.json());

/**
 * A hook for pulling in election results from S3.
 *
 * @param {string} url The URL to processed results on S3
 * @param {number} [interval] How frequently to request the data, in seconds
 * @returns {any}
 */
function useElectionResults(interval = 60) {
  const [results, setResults] = useState([]);

  const getResults = () => {
    fetchResults().then(raw => {
      const data = raw.map(d => {
        const id = RACE_MAPPING[d.record_number];

        const { record_type, precincts_total, precincts_reporting } = d;
        const precincts_reporting_pct = (
          d.precincts_reporting_pct * 100
        ).toFixed(1);

        const candidates = prepareResults(d);

        return {
          id,
          precincts_total,
          precincts_reporting,
          precincts_reporting_pct,
          record_type,
          candidates,
          record: d.record_number,
        };
      });

      setResults(data);
    });
  };

  useInterval(getResults, 1000 * interval, true);

  return results;
}

function App() {
  const results = useElectionResults();

  return (
    <Fragment>
      {results.map(result => (
        <Result key={result.id} containerId={result.id} {...result} />
      ))}
    </Fragment>
  );
}

render(<App />, document.getElementById('app'));

if (process.env.NODE_ENV === 'development') {
  require('preact/debug');
}
